// Enrollment status reference — mirrors MembersList/enums/subscriptionStatuses.js.
// `tone` maps 1:1 to a StatusChip variant: StatusChip[Success|Error|Alert|Info|Default].
// See ClickUp 868jxkz4p §3.
export const ENROLLMENT_STATUSES = [
  { id: "pending", label: "Pendente", tone: "alert" },
  { id: "awaiting_community", label: "Aguardando comunidade", tone: "info" },
  { id: "active", label: "Em andamento", tone: "success" },
  { id: "split_only", label: "Repasse ativo", tone: "info" },
  { id: "rejected", label: "Recusado", tone: "error" },
  { id: "declined", label: "Recusado pelo convidado", tone: "error" },
  { id: "ended", label: "Encerrado", tone: "default" },
];

export const ENROLLMENT_STATUS_LABEL = ENROLLMENT_STATUSES.reduce(
  (acc, status) => ({ ...acc, [status.id]: status.label }),
  {}
);

export const ENROLLMENT_STATUS_TONE = ENROLLMENT_STATUSES.reduce(
  (acc, status) => ({ ...acc, [status.id]: status.tone }),
  {}
);

// StatusChip variant component keyed by tone, e.g. STATUS_CHIP_VARIANT["success"] → "Success".
export const STATUS_CHIP_VARIANT = {
  success: "Success",
  error: "Error",
  alert: "Alert",
  info: "Info",
  default: "Default",
};
